import { gql, useLazyQuery } from '@apollo/client'
import { Query } from '@promoboxx/graphql-gateway-types'
import queryString from 'query-string'
import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router'

import DigitalAssetDialog from './DigitalAssetDialog'

// Ideally there would only be one Dialog for Digital Assets. At the time of
// writing, however, the API provides no way for us to get advanced information
// like `description` and `tag_list` with only a digital asset id.

const PARAM_NAME = 'digitalAssetDialogId'

const DigitalAssetPermalinkDialog: React.FC<React.PropsWithChildren> = () => {
  const history = useHistory()
  const location = useLocation()
  const [runQuery, { data }] = useLazyQuery<Query>(GET_DIGITAL_ASSET, {
    // HACK Something weird is going on with this. When a query is made for a
    // specific digital asset, it's removed from any list via Apollo's cache.
    fetchPolicy: 'no-cache',
  })

  const digitalAssetId = queryString.parse(location.search)[PARAM_NAME]

  useEffect(() => {
    if (digitalAssetId) {
      runQuery({
        variables: {
          id: digitalAssetId,
          fields: [
            'is_folder',
            'tag_list',
            'associable_id',
            'digital_asset_associable_id',
            'file_url',
          ],
        },
      })
    }
  }, [digitalAssetId, runQuery])

  const onClose = () => {
    const params = new URLSearchParams(location.search)
    params.delete(PARAM_NAME)
    history.push({ search: params.toString() })
  }

  return (
    <DigitalAssetDialog
      open={!!digitalAssetId}
      onClose={onClose}
      digitalAsset={data?.getDigitalAsset}
    />
  )
}

export default DigitalAssetPermalinkDialog

const GET_DIGITAL_ASSET = gql`
  query getDigitalAssetPermalinkDialog($id: ID!, $fields: [String!]) {
    getDigitalAsset(params: { id: $id, fields: $fields }) {
      # associable_id
      is_folder
      tag_list
      external_video_url
      aspect_ratio_maximum
      aspect_ratio_minimum
      category
      created_at
      crop_height
      crop_origin_x
      crop_origin_y
      crop_width
      description
      digital_asset_id
      digital_asset_associable_id
      download_url
      eligible_share_types {
        facebook {
          link
          photo
          video
        }
      }
      file {
        id
        public_id
        version
        width
        height
        format
        resource_type
        path
        bytes
      }
      file_url
      id
      name
      original_share_image_url
      resource_type
      responsive_share_image_url
      share_image_url
      async_completed_at
      source
      updated_at
    }
  }
`
